import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Image } from '../../components/Image/Image'
import { GameWrapper } from '../../components/GameWrapper/GameWrapper'
import { CustomDnd } from '../../components/CustomDnd/CustomDnd'
import cleanMapImg from '../../resources/cleanMap.png'
import { getIsLangRu } from '../../store/langSlice'

import styles from './GameKamaz.module.scss'
import checkImg from './check.png'
import kamaz00Img from './kamaz-00.png'
import kamaz01Img from './kamaz-01.png'
import kamaz02Img from './kamaz-02.png'
import kamaz03Img from './kamaz-03.png'
import kamaz04Img from './kamaz-04.png'
import kamaz05Img from './kamaz-05.png'
import kamazPart00Img from './kamaz-part-00.png'
import kamazPart01Img from './kamaz-part-01.png'
import kamazPart02Img from './kamaz-part-02.png'
import kamazPart03Img from './kamaz-part-03.png'
import kamazPart04Img from './kamaz-part-04.png'
import kamazPart05Img from './kamaz-part-05.png'
import descRuImg from './desc-ru.png'
import descTtImg from './desc-tt.png'

const KAMAZ_IMG_LIST = [
    kamaz00Img,
    kamaz01Img,
    kamaz02Img,
    kamaz03Img,
    kamaz04Img,
    kamaz05Img,
]

const KAMAZ_PARTS_IMG_LIST = [
    kamazPart00Img,
    kamazPart01Img,
    kamazPart02Img,
    kamazPart03Img,
    kamazPart04Img,
    kamazPart05Img,
]

function GameKamazBody({ isLangRu }) {
    const [win1, setWin1] = useState(false)
    const [win2, setWin2] = useState(false)
    const [doneParts, setDoneParts] = useState([])
    const [selectedKamaz1, setSelectedKamaz1] = useState(null)
    const [selectedKamaz2, setSelectedKamaz2] = useState(null)

    const onDrop = useCallback((draggable, droppable) => {
        if (win1) {
            return
        }

        if (draggable === droppable && !doneParts.includes(draggable)) {
            setDoneParts([...doneParts, draggable])
        }
    }, [win1, doneParts, setDoneParts])

    useEffect(() => {
        if (doneParts.length === KAMAZ_IMG_LIST.length) {
            setWin1(true)
        }
    }, [doneParts, setWin1])

    const kamazClicked = useCallback((index) => {
        if (!win1 || win2) {
            return
        }

        if (selectedKamaz1 === index) {
            setSelectedKamaz1(null)
        } else if (
            (selectedKamaz1 === '1' && index === '3')
            || (selectedKamaz1 === '3' && index === '1')
        ) {
            setSelectedKamaz2(index)
            setWin2(true)
        } else {
            setSelectedKamaz1(index)
        }
    }, [win1, win2, selectedKamaz1, setSelectedKamaz1, setSelectedKamaz2])

    return (
        <GameWrapper win={win2} people="1">
            <CustomDnd onDropped={onDrop} className={styles.customDnd}>
                <Image src={cleanMapImg} className={styles.bg} />

                {
                    KAMAZ_IMG_LIST.map((img, index) => (
                        <div key={img}>
                            <Image
                                src={img}
                                className={classNames(
                                    `kamaz-0${index}`,
                                    {
                                        [styles.done]: win1,
                                        [styles.selected]: (
                                            selectedKamaz1 === index.toString() || selectedKamaz2 === index.toString()
                                        ),
                                    },
                                )}
                                droppable={index.toString()}
                                onMouseDown={() => kamazClicked(index.toString())}
                            />
                            {
                                selectedKamaz1 === index.toString() || selectedKamaz2 === index.toString()
                                    ? (
                                        <Image
                                            src={checkImg}
                                            className={classNames(`kamaz-0${index}`, styles.checkbox)}
                                            isNeedRegisterResource={false}
                                        />
                                    )
                                    : null
                            }
                        </div>
                    ))
                }

                {
                    KAMAZ_PARTS_IMG_LIST.map((img, index) => (
                        <Image
                            key={img}
                            src={img}
                            className={classNames(
                                `kamaz-part-0${index}`,
                                {
                                    [styles.done]: doneParts.includes(index.toString()),
                                    [styles.doneDone]: win1,
                                },
                            )}
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...(
                                !win1 && !doneParts.includes(index.toString()) ? { draggable: index.toString() } : {}
                            )}
                            onMouseDown={() => kamazClicked(index.toString())}
                        />
                    ))
                }

                {
                    win1
                        ? (
                            <Image
                                src={isLangRu ? descRuImg : descTtImg}
                                isNeedRegisterResource={false}
                                className={styles.desc}
                            />
                        )
                        : null
                }
            </CustomDnd>
        </GameWrapper>
    )
}

GameKamazBody.propTypes = {
    isLangRu: PropTypes.bool.isRequired,
}

const GameKamaz = connect(
    state => ({
        isLangRu: getIsLangRu(state),
    }),
)(GameKamazBody)

GameKamaz.propTypes = {}

export { GameKamaz }
